module.exports = __webpack_public_path__ + "img/rr-logo-horizontal.c3d4aee6.png";